import Vue from 'vue';
import Router from 'vue-router';
import Catalog from './components/Catalog.vue';

Vue.use(Router);

export function createRouter() {
  const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
      {
        path: '/catalog/search',
        name: 'search',
        component: Catalog,
      },
      {
        path: '/catalog/store/:store',
        name: 'store',
        component: Catalog,
      },
      {
        path: '/catalog/brand/:brand',
        name: 'brand',
        component: Catalog,
      },
      {
        path: '/catalog/fair-fashion-alternatives/image-search',
        name: 'image',
        component: Catalog,
      },
      {
        path: '/catalog/:section/:category/:subcategory?', // /:locale?
        name: 'catalog',
        component: Catalog,
      },
    ],
  });
  router.afterEach(to => {
    if (typeof window === 'object') {
      window.tracking.setCustomUrl(to.fullPath);
      window.tracking.trackPageView();
      window.tracking.trackContentImpressions();
    }
  });
  return router;
}
